<template>
  <calc-form-card>
    <template slot="controls">
      <b-switch v-model="isSpanBySpan" class="is-label_left">{{
        $t("Definir valor por vão")
      }}</b-switch>
    </template>

    <calc-form-item :title="title">
      <div>
        <transition-group name="anim-slideX">
          <div v-for="(group, i) in loads" :key="`key-${i}`" class="group">
            <div class="main_fields">
              <div class="fields_grid">
                <calc-number-input
                  v-model="group.value[0]"
                  :min="-100"
                  :max="100"
                  label="P1"
                  addon="kN"
                />

                <calc-number-input
                  v-model="group.value[2]"
                  :min="-100"
                  :max="100"
                  label="P2"
                  addon="kN"
                />
              </div>

              <div class="fields_grid">
                <calc-number-input
                  v-model="group.value[1]"
                  :min="0"
                  :max="100"
                  label="L1"
                  addon="%"
                />

                <calc-number-input
                  v-model="group.value[3]"
                  :min="0"
                  :max="100"
                  label="L2"
                  addon="%"
                />
              </div>
            </div>

            <transition name="anim-slideX">
              <div v-if="isSpanBySpan" class="span_select__row">
                <b-field
                  class="
                    span_select__btn_group
                    field--labelPosAbsolute
                    has-addons
                  "
                  :label="$t('Aplicar em vãos')"
                >
                  <b-checkbox-button
                    class="span_select__btn_group_btn"
                    v-for="j in totalSpans"
                    :key="j"
                    v-model="group.span"
                    :disabled="isSpanUsedInOtherGroup(j, group)"
                    :native-value="j"
                    type="is-primary"
                  >
                    {{ spanSelectBtnText(j) }}
                  </b-checkbox-button>
                </b-field>

                <b-button
                  class="remove_group_btn"
                  v-if="loads.length > 1"
                  @click="() => deleteLoadGroupByIdx(i)"
                  size="is-medium"
                  type="is-text"
                  icon-right="delete"
                  >{{ $t("Remover grupo") }}</b-button
                >
              </div>
            </transition>
          </div>
        </transition-group>
      </div>

      <transition name="anim-slideX">
        <div
          class="add_new_group_btn_row"
          v-if="isSpanBySpan && loads.length < 4"
        >
          <b-button
            @click="addLoadGroup"
            size="is-medium"
            type="is-text"
            icon-right="plus"
            >{{ $t("Adicionar novo grupo") }}</b-button
          >
        </div>
      </transition>

      <template slot="illustration">
        <calc-illustration
          which="loadPoint"
          :position="isSpanBySpan ? 'relative' : 'absolute'"
        />
      </template>
    </calc-form-item>
  </calc-form-card>
</template>

<script>
import { lastOf } from "@/utils";
import { mapState, mapGetters } from "vuex";
import CalcIllustration from "./CalcIllustration";

export default {
  components: {
    CalcIllustration,
  },

  props: {
    title: {
      type: String,
      default: "Título por definir (prop.title)",
    },
    theCase: {
      required: true,
      validator: (val) => ["permanent", "live"].includes(val),
    },
  },

  data() {
    return {
      isSpanBySpan: undefined,
    };
  },

  computed: {
    ...mapState("calculator", ["calculation"]),
    ...mapGetters("calculator", ["totalSpans"]),

    loads() {
      return this.calculation.input.internal.loads.points[this.theCase];
    },

    spanSelectBtnText() {
      return (j) => {
        if (this.calculation.input.hasCantilever) {
          if (j == 1) {
            return "C1";
          } else if (j === this.totalSpans) {
            return "C2";
          } else {
            return j - 1;
          }
        }

        return j;
      };
    },

    isSpanUsedInOtherGroup() {
      return (span, thisGroup) => {
        return this.loads.some(
          (group) => group.span.includes(span) && group !== thisGroup
        );
      };
    },
  },

  watch: {
    isSpanBySpan(val) {
      const { loads, totalSpans } = this;

      if (!val) {
        // SWITCH OFF
        this.calculation.input.internal.loads.points[this.theCase] = [
          {
            value: loads[0].value, //first
            span: Array(totalSpans)
              .fill()
              .map((x, i) => i + 1),
          },
        ];
      }
    },
  },

  methods: {
    addLoadGroup() {
      const { loads } = this;

      loads.push({
        value: [...lastOf(loads).value],
        span: [], //Array(this.totalSpans).fill().map((x,i)=>i+1)
      });
    },

    deleteLoadGroupByIdx(idx) {
      this.loads.splice(idx, 1);
    },
  },

  created() {
    const { loads, totalSpans } = this;

    if (loads.length === 1) {
      this.isSpanBySpan = loads[0].span.length !== totalSpans;
    } else {
      this.isSpanBySpan = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.group {
  position: relative;
  z-index: 1;

  &:not(:last-child) {
    border-bottom: 1px solid #eee;
    padding-bottom: 20px;
    margin-bottom: 20px;
  }
}

.remove_group_btn {
  position: absolute;
  right: 0;
  top: 6px;
}

.main_fields {
  margin-bottom: 1em;
}

.span_select__btn_group {
  margin-right: 8px;
}
.span_select__btn_group_btn {
  width: 24px;
}

.field.has-addons .span_select__btn_group_btn:not(:last-child) {
  margin-right: 1px;
}

.add_new_group_btn_row {
  border-top: 1px solid #eee;
  padding-top: 20px;
  margin-top: 20px;
  margin-bottom: 32px;
}
</style>
